"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRedirectURIValid = void 0;
var url_1 = require("url");
var isRedirectURIValid = function (uri) {
    try {
        var u = new url_1.URL(uri);
        if (u.protocol === 'https:') {
            return true;
        }
        if ((u.hostname === 'localhost' || u.hostname === '127.0.0.1') && u.protocol === 'http:') {
            return true;
        }
    }
    catch (err) {
        return false;
    }
    return false;
};
exports.isRedirectURIValid = isRedirectURIValid;
